import { useTheme } from '@mui/material';

export const CopyIcon = () => {
    const theme = useTheme();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                d="M39.6665 34.9999H27.9998C26.7092 34.9999 25.6665 33.9572 25.6665 32.6666V13.9999C25.6665 12.7093 26.7092 11.6666 27.9998 11.6666H35.8821C36.1884 11.6666 36.4873 11.7905 36.7061 12.0093L41.6571 16.9603C41.8759 17.1791 41.9998 17.478 41.9998 17.7843V32.6666C41.9998 33.9572 40.9571 34.9999 39.6665 34.9999ZM43.305 15.3051L38.3613 10.3614C37.705 9.70513 36.8155 9.33325 35.8894 9.33325H27.9998C25.4259 9.33325 23.3332 11.426 23.3332 13.9999V32.6666C23.3332 35.2405 25.4259 37.3333 27.9998 37.3333H39.6665C42.2405 37.3333 44.3332 35.2405 44.3332 32.6666V17.7843C44.3332 16.8583 43.9613 15.9687 43.305 15.3124V15.3051ZM16.3332 18.6666C13.7592 18.6666 11.6665 20.7593 11.6665 23.3333V41.9999C11.6665 44.5739 13.7592 46.6666 16.3332 46.6666H27.9998C30.5738 46.6666 32.6665 44.5739 32.6665 41.9999V39.6666H30.3332V41.9999C30.3332 43.2905 29.2905 44.3333 27.9998 44.3333H16.3332C15.0425 44.3333 13.9998 43.2905 13.9998 41.9999V23.3333C13.9998 22.0426 15.0425 20.9999 16.3332 20.9999H20.9998V18.6666H16.3332Z"
                fill={theme.colors.other.icon.stroke.tertiary}
            />
        </svg>
    );
};
